import { useDebugValue } from 'react';
import { useToken } from 'reakit-system/useToken';
import 'color';
import './isLight.js';
import './contrast.js';
import { palette } from '../palette.js';
import './ref.js';

function getPalette(palette$1, name) {
  if (palette$1 === void 0) {
    palette$1 = palette;
  }

  if (!name) return undefined;
  var color = palette$1[name];

  while (typeof color === "function") {
    color = color(palette$1);
  }

  return color;
}

function usePalette(name) {
  useDebugValue(name);
  var palette = useToken("palette");
  return getPalette(palette, name);
}

export { getPalette, usePalette };